import { useCallback, useEffect, useRef, useState } from "react";
import { Col, Container, Row, Spinner } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { CSVLink } from "react-csv";

import { FaFolder } from "react-icons/fa";
import { PaginationList } from "../../../../components/pagination";
import { TreeTableProductsList } from "../../components/table-products";
import { ProductsFilters } from "../components/products-filter";
import { ContentBody, ContentHeader } from "./styled"

import { FiltersProps } from "../../../../@types";
import { locationExportData, managerLocation } from "../../../../services/manager.service";
import { Dropdown } from "primereact/dropdown";
import exportFromJSON from "export-from-json";

export const LocationList = (): JSX.Element => {
    const { t: translation } = useTranslation();
    const buttonRef = useRef<any>(null)

    //Pagination
    const [totalItens, setTotalItens] = useState(0)
    const [currentPage, setCurrentPage] = useState(1)

    const [sortOrder, setSortOrder] = useState(1);
    const [sortField, setSortField] = useState("name");
    const [filters, setFilters] = useState<FiltersProps>({});

    const [exportListCsv, setExportListCsv] = useState([]);
    const [exportListXml, setExportListXml] = useState<any>();
    const [locationList, setLocationList] = useState([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [showEmptyMessage, setShowEmptyMessage] = useState<boolean>(false);
    const [exportSelected, setExportSelected] = useState("");

    const exportOptions = [
        { label: 'CSV', value: "csv" },
        { label: 'XML', value: "xml" },
    ];

    const headersCsv = [
        { label: "Nome da disciplina", key: "discipline" },
        { label: "Nome da unidade", key: "unity" },
        { label: "Nome do objeto", key: "objects" },
    ];

    const handleExport = (typeExport: string) => {
        setExportSelected(typeExport)

        if (typeExport === 'csv') {
            buttonRef.current.link.click()
        } else {
            const data = exportListXml;
            const fields = [
                "discipline",
                "unity",
                "objects",
            ]
            const exportType = 'xml';
            const fileName = 'materials';
            exportFromJSON({data, fileName, fields, exportType})
        }
    }

    const treeTableConfig = [
        { field: 'title', header: 'Nome', nameTemplate: true, expander: true, sortable: true, style: { textAlign: 'left', width: '35%' }, },
        { field: 'type_name', header: 'Tipo', sortable: false, style: { textAlign: 'center' } },
        { field: 'code', header: 'Código', sortable: true, style: { textAlign: 'center' } },
        { field: 's', header: 'Utilização', sortable: true, style: { textAlign: 'center' } },
        { field: 'ss', header: 'Acessos externos', sortable: true, style: { textAlign: 'center' } },
    ]
    
    const handleFilters = (event?: any) => {
        setFilters({ ...event, 'page': 1 });
    }

    const handlePageChange = (event?: any) => {
        window.scrollTo(0, 0);
        setFilters({ ...filters, 'page': event });
        setCurrentPage(event)
    }

    const handleTableSort = useCallback((event: any) => {
        let order = event.sortOrder > 0 ? event.sortField : '-' + event.sortField;
        
        setSortOrder(event.sortOrder);
        setSortField(event.sortField);

        managerLocation(`ordering=${order}`).then(data => {
            if (data.results.length === 0) {
                setShowEmptyMessage(true)
            } else {
                setShowEmptyMessage(false)
            }
            setLocationList(data.results);
            setTotalItens(data.count);
        }).finally(() => {
            setLoading(false)
        })
    }, []);

    useEffect(() => {
        setLoading(true)
        managerLocation().then(data => {
            if (data.results.length === 0) {
                setShowEmptyMessage(true)
            } else {
                setShowEmptyMessage(false)
            }
            setLocationList(data.results);
            setTotalItens(data.count);
        }).finally(() => {
            setLoading(false)
        })

        locationExportData().then((resp) => {
            let dataCsv: any = []

            resp.map((item: any) => (
                item.data.items.map((unity: any) => {
                    if (unity.objects.length > 0) {
                        unity.objects.map((object: any) => {
                            let obj = {
                                discipline: item.data.discipline,
                                unity: unity.item,
                                objects: object.title,
                            }
                            dataCsv.push(obj)
                        })
                    } else {
                        let obj = {
                            discipline: item.data.discipline,
                            unity: unity.item,
                            objects: ""
                        }
                        dataCsv.push(obj)
                    }
                })
            ))

            
            const data = resp.map((item: any) => ({
                discipline: item.data.discipline,
                unity: item.data.items.map((unity: any) => unity.item),
                objects: item.data.items.map((unity: any) => unity.objects.map((object: any) => object.title)),
            }))

            setExportListCsv(dataCsv)
            setExportListXml(data)
        })
    }, [])

    useEffect(() => {
        if (filters && filters.page) {
            setLoading(true)
            managerLocation(filters).then(data => {
                if (data.results.length === 0) {
                    setShowEmptyMessage(true)
                } else {
                    setShowEmptyMessage(false)
                }
                setLocationList(data.results);
                setTotalItens(data.count);
            }).finally(() => {
                setLoading(false)
            })
        }
    }, [filters])

    const csvReport = {
        data: exportListCsv,
        headers: headersCsv,
        filename: 'materials.csv'
    };

    return (
        <Container fluid>
            <ContentHeader>
                <Row>
                    <div className="title">Materiais Locação
                        <span className="subtitle">{totalItens} resultados</span>
                    </div>
                </Row>
            </ContentHeader>
            <ContentBody>
                <Row className="mt-4">
                    <ProductsFilters handleFilter={handleFilters} showMaterialType={false}/>
                    <Col xs={12} md={4} lg={2}>
                        <Dropdown
                            className="w-100 select-form-default"
                            value={exportSelected}
                            options={exportOptions}
                            onChange={(e) => handleExport(e.value)} 
                            placeholder="Exportar"
                        />
                    </Col>
                </Row>

                <CSVLink {...csvReport} ref={buttonRef} className="d-none">Exportar CSV</CSVLink>

                <Row className="mt-5">
                    {
                        loading ? (
                            <div className="loading-container mt-5">
                                <Spinner animation="border" variant="primary" />
                            </div>
                        ) : (
                            <>
                                {
                                    showEmptyMessage ? (
                                        <div className="text-center text-grey mt-5">
                                            <FaFolder className="mt-5" size={100} />
                                            <h5 className="text-grey">{translation("manager.products.emptyMaterials")}</h5>
                                        </div>
                                    ) : (
                                        <TreeTableProductsList 
                                            treeFields={treeTableConfig} 
                                            nodes={locationList}
                                            handleTableSort={handleTableSort}
                                            sortField={sortField} 
                                            sortOrder={sortOrder}
                                        />
                                    )
                                }
                            </>
                        )
                    }
                </Row>
                <Row className="mt-5">
                    <PaginationList currentPage={currentPage} totalItems={totalItens} onPageChange={handlePageChange}></PaginationList>
                </Row>
            </ContentBody>
        </Container>
    )
}